export default "__VITE_ASSET__09f9bd6b__"